module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.b270c40a.ttf";